<template>
  <el-container class="h-full" :class="{ 'large-font-mode': largeFontMode }">
    <!--  主页面 start  -->
    <el-main style="height: 100%">
      <div class="flex flex-row h-full">
        <!--    挂号 start    -->
        <el-card class="register-con self-stretch">
          <div class="flex flex-col cursor-pointer" @click="enroll">
            <img
              src="@/assets/treatment/register.png"
              alt=""
              class="register-logo"
            >
          </div>
          <patients ref="patients" style="width: 176px" />
        </el-card>
        <!--    挂号 end    -->
        <!--    诊疗 start    -->
        <div v-if="activePatientInfo && Object.keys(activePatientInfo).length" class="treatment-con" style="display: flex; flex-direction: column; height: 100%;">
          <el-card>
            <template>
              <div class="patient-header">
                <div class="header-left">
                  <img
                    src="@/assets/treatment/profile-img.png"
                    class="header-avatar"
                    alt="头像"
                  >
                  <div class="header-info">
                    <div class="info-row">
                      <span class="patient-name">{{ activePatientInfo.name || "-" }}</span>
                      <span class="patient-meta">{{ activePatientInfo.sexSign ==='1'?'男':'女' }}/{{ calculateAge(activePatientInfo.birthDate) }}岁</span>
                      <el-tag
                        v-if="tizhi && Object.keys(tizhi).length > 0"
                        :type="getTizhiType()"
                        size="small"
                        effect="dark"
                      >
                        <i class="el-icon-first-aid-kit" />
                        {{ getTizhiText() }}
                      </el-tag>
                      <el-tag
                        v-else
                        type="info"
                        size="small"
                        effect="plain"
                      >
                        <i class="el-icon-question" />
                        未辨识
                      </el-tag>
                      <span class="patient-phone">{{ activePatientInfo.contactPhone || "-" }}</span>
                    </div>
                    <div v-if="activePatientInfo.label || activePatientInfo.patientRemark" class="tag-row">
                      <el-tag v-if="activePatientInfo.label" size="small" type="primary">
                        <i class="el-icon-s-order" /> {{ activePatientInfo.label }}
                      </el-tag>
                      <el-tag v-if="activePatientInfo.patientRemark" size="small" type="info">
                        <i class="el-icon-edit-outline" /> {{ activePatientInfo.patientRemark }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="header-right">
                  <div class="info-line info-with-action">
                    <div class="info-group">
                      <span class="info-item">
                        <label>出生日期：</label>
                        <value>{{ activePatientInfo.birthDate || '未知' }}</value>
                      </span>
                      <span class="divider">|</span>
                      <span class="info-item">
                        <label>就诊状态：</label>
                        <value :class="'state-'+activeDiagRecord.diagRecord.stateSign">
                          {{ getStateText(activeDiagRecord.diagRecord.stateSign) }}
                        </value>
                      </span>
                      <span class="divider">|</span>
                      <span class="info-item">
                        <label>病历号：</label>
                        <value>{{ activeDiagRecord.diagRecord.code || '-' }}</value>
                      </span>
                    </div>
                    <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-refresh"
                      class="switch-btn"
                      @click="cardShow = !cardShow"
                    >{{ cardShow ? '历史记录':'诊断开方' }}
                    </el-button>
                  </div>
                  <div class="info-line secondary-line">
                    <span v-if="activePatientInfo.contactAddress" class="info-item">
                      <label>地址：</label>
                      <value>{{ activePatientInfo.contactAddress }}</value>
                    </span>
                    <span v-else class="placeholder" />
                  </div>
                </div>
              </div>
            </template>
          </el-card>
          <el-card v-if="cardShow" class="treatment-body-card">
            <template>
              <div class="flex flex-row justify-between" style="margin-bottom: 10px; ">
                <div />
                <div class="flex flex-row align-center">
                  <el-button
                    v-show="['1'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1"
                    size="mini"
                    type="success"
                    icon="el-icon-microphone"
                    @click="voiceConsultationVisible = true"
                  >语音问诊</el-button>
                  <el-button v-show="['1'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1" size="mini" type="primary" @click="handleTreatment">确认诊断</el-button>
                  <el-button
                    v-show="['2'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1"
                    size="mini"
                    type="primary"
                    @click="prepareMed"
                  >确认处方
                  </el-button>
                  <el-button
                    v-show="['2','3'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1"
                    size="mini"
                    type="primary"
                    @click="peiyao"
                  >配药
                  </el-button>
                  <el-button
                    v-show="activeDiagRecord.diagRecord.stateSign==='3'"
                    size="mini"
                    type="primary"
                    @click="pay"
                  >支付
                  </el-button>
                  <el-button
                    v-show="activeDiagRecord.diagRecord.stateSign==='4'"
                    size="mini"
                    type="primary"
                    @click="dispatchMed"
                  >发药
                  </el-button>
                  <el-button
                    v-show="['2'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1"
                    size="mini"
                    type="primary"
                    @click="resetDiag"
                  >重新诊断
                  </el-button>
                  <el-button
                    v-show="activeDiagRecord.diagRecord.stateSign==='4'"
                    size="mini"
                    type="primary"
                    @click="printOpen()"
                  >
                    打印
                  </el-button>
                </div>
              </div>
            </template>
            <div class="body flex flex-col" style="width: 100%; height: calc(100% - 60px); overflow: auto;">
              <treatment-form ref="treatmentForm" />
              <div class="divider-line w-full" />
              <treatment-form2 ref="treatmentForm2" />
              <div class="divider-line w-full" />
              <div v-if="['1'].indexOf( activeDiagRecord.treatmentRecord.executeSign)>-1" class="flex-row align-center flex" style="width: 100%; justify-content: end;">
                <tcm-rx2
                  v-if="currentTreatmentTab != 3 && currentTreatmentTab != 2 && currentTreatmentTab != 5"
                  ref="tcmRx2"
                  :search-key-word="searchKeyWord"
                  class="mr-10"
                  url="clinic/treatment/stdprescription/stdprescription"
                  @show="handleShow"
                  @onPopupClick="handlePopupClick"
                  @handleOpenClick="handleOpenClick2"
                >搜索处方
                </tcm-rx2>
                <TcmRxCPD2
                  v-if="currentTreatmentTab == 2"
                  ref="TcmRxCPD2Ref"
                  :search-key-word="searchKeyWord"
                  class="mr-10"
                  url="clinic/treatment/stdprescription/stdmedprescription"
                  @show="handleShow"
                  @onPopupClick="handleMedicationSelect"
                  @handleOpenClick="handleCPDOpenClick"
                >
                  搜索中成药
                </TcmRxCPD2>
                <tcm-rx
                  v-if="currentTreatmentTab != 3 && currentTreatmentTab != 2 && currentTreatmentTab != 5"
                  ref="tcmRx"
                  :search-key-word="searchKeyWord"
                  class="mr-10"
                  :ch-diag-content="activeDiagRecord.treatmentRecord.chDiagContent"
                  :prescription-types-sign="1"
                  url="clinic/treatment/stdprescription/stdprescription"
                  @show="handleShow"
                  @onPopupClick="handlePopupClick"
                  @handleOpenClick="handleOpenClick"
                >推荐处方
                </tcm-rx>
                <TcmRxCPD
                  v-if="currentTreatmentTab == 2"
                  ref="TcmRxCPDRef"
                  :search-key-word="searchKeyWord"
                  :store-code="storeCode"
                  :diag-content="activeDiagRecord.treatmentRecord.diagContent"
                  :ch-diag-content="activeDiagRecord.treatmentRecord.chDiagContent"
                  :ch-yndrome-content="activeDiagRecord.treatmentRecord.chYndromeContent"
                  :phy-content="activeDiagRecord.treatmentRecord.phyContent"
                  :tab-content="activeDiagRecord.treatmentRecord.tabContent || ''"
                  class="mr-10"
                  url="clinic/treatment/stdprescription/stdmedprescription"
                  @show="handleShow"
                  @onPopupClick="handleMedicationSelect"
                  @handleOpenClick="handleCPDOpenClick"
                >
                  中成药推荐
                </TcmRxCPD>
                <el-button
                  size="mini"
                  type="primary"
                  @click="saveChufang"
                >
                  保存处方
                </el-button>
                <el-button
                  v-if="currentTreatmentTab != 4 && currentTreatmentTab != 5"
                  size="mini"
                  type="primary"
                  @click="clearPrescription"
                >
                  清空处方
                </el-button>
              </div>
              <treatment v-show="['1','2','3','4'].indexOf( activeDiagRecord.diagRecord.stateSign)>-1" ref="treatment" @command="handleTreatmentCommand" @tab-change="handleTreatmentTabChange" />
            </div>
          </el-card>
          <el-card v-else class="history-container">
            <div class="flex flex-row w-full">
              <div class="w-3/10 pr-4 history-section" style="width: 30%;">
                <div v-if="activeDiagRecord.preTreatmentRecord!==null && activeDiagRecord.preTreatmentRecord!==undefined">
                  <pre-diag-record />
                </div>
                <div v-else class="no-data flex flex-col w-full align-center justify-center">
                  <span class="no-data-label">抱歉, 暂无相关数据</span>
                </div>
              </div>
              <div class="w-7/10 history-section" style="width: 100%; height: 70vh;">
                <div v-if="hisTreatmentRecords.length>0" class="history-content">
                  <div class="diagnosis-record-con">
                    <el-timeline class="history-timeline">
                      <el-timeline-item
                        v-for="record in hisTreatmentRecords"
                        :key="record.id"
                        type="primary"
                      >
                        <diagnosis-record
                          :record="record"
                          class="record"
                          @command="handleDiagnosisRecord"
                        />
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
                <div v-else class="no-data flex flex-col w-full align-center justify-center">
                  <span class="no-data-label">抱歉, 暂无相关数据</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
        <div v-else class="no-patient-tip" style="flex: 1; display: flex; align-items: center; justify-content: center; color: #999;">
          请从左侧选择一位病人开始诊疗
        </div>
        <!--    诊疗 end    -->
      </div>
    </el-main>
    <!--  主页面 end  -->
    <!--  挂号 start  -->
    <el-dialog title="挂号" :visible.sync="enrollVisible">
      <enroll-form ref="enrollForm" @command="handleEnrollCommand" />
      <template #footer>
        <el-button size="small" @click="enrollVisible=false">取消</el-button>
        <el-button type="primary" size="small" @click="handleEnroll">确认</el-button>
      </template>
    </el-dialog>
    <!--  挂号 end  -->
    <!--  配药弹窗 start  -->
    <el-dialog :modal="false" title="配药" :visible.sync="prepareVisible">
      <prepare-med />
      <template #footer>
        <el-button type="primary" size="mini" @click="resetDiag">重诊</el-button>
        <el-button type="primary" size="mini" @click="pay">支付</el-button>
      </template>
    </el-dialog>
    <!--  配药弹窗 end  -->
    <!--  支付弹窗 start  -->
    <el-dialog width="479px" :visible.sync="payVisible" title="支付结算">
      <pay />
    </el-dialog>
    <!--  支付弹窗 end  -->
    <!--  二维码 start  -->
    <el-dialog
      width="479px"
      :destroy-on-close="true"
      :show-close="false"
      :modal="false"
      custom-class="qrcode-con"
      :visible.sync="qrcodeVisible"
    >
      <div class="flex flex-col align-center">
        <div class="flex flex-row align-center pay-header">
          <img
            v-if="payWay==='aliPay'"
            src="@/assets/list/aliPay.png"
            alt=""
            class="icon-img"
          >
          <img
            v-if="payWay==='wechat'"
            src="@/assets/list/wechat.png"
            alt=""
            class="icon-img"
          >
          <span class="tip">请使用{{ payWay|PAY_WAY }}扫码支付</span>
        </div>
        <div ref="qrcode" />
      </div>
    </el-dialog>
    <!--  二维码 end  -->
    <!--  发药 start  -->
    <el-dialog title="发药" :visible.sync="dispatchVisible">
      <dispatch-med />
    </el-dialog>
    <!--  发药 end  -->
    <whitePrescribeModal ref="whitePrescribeModal" />
    <video-call-dialog
      ref="videoCallDialog"
      :sdk-app-id="1400539979"
    />
    <voice-consultation-modal
      :visible.sync="voiceConsultationVisible"
      @complete="handleVoiceComplete"
    />
    <!--  语音问诊弹窗 end  -->
  </el-container>
</template>

<script>
import DiagnosisRecord from "@/views/business/page/treatment/treatment/diagnosisRecord/DiagnosisRecord.vue"
import TreatmentForm from "@/views/business/page/treatment/treatment/treatment/TreatmentForm.vue"
import TcmRx from "@/components/TCMRx/TcmRx.vue"
import TcmRxCPD from "@/components/TCMRx/TcmRxCPD.vue"
import TcmRxCPD2 from "@/components/TCMRx/TcmRxCPD2.vue"
import Patients from "@/views/business/page/treatment/treatment/patients/Patients.vue"
import Treatment from "@/views/business/page/treatment/treatment/treatment/Treatment.vue"
import PrepareMed from "@/views/business/page/treatment/treatment/treatment/PrepareMed.vue"
import Pay from "@/views/business/page/treatment/treatment/treatment/Pay.vue"
import DispatchMed from "@/views/business/page/treatment/treatment/treatment/DispatchMed.vue"
import { findPage, postData, getData } from '@/api/ik/data/dataApi'
import QRCode from "qrcodejs2"
import { getByCode } from "@/api/ik/data/dataApi"
import EnrollForm from "@/views/business/page/treatment/treatment/patients/EnrollForm.vue"
import PreDiagRecord from "@/views/business/page/treatment/treatment/diagnosisRecord/PreDiagRecord.vue"
import TreatmentForm2 from "./treatment/TreatmentForm2.vue"
import whitePrescribeModal from "./treatment/white-prescribe-modal/white-prescribe-modal.vue"
import TcmRx2 from "@/components/TCMRx/TcmRx2.vue"
import VideoCallDialog from "@/components/videoCall/VideoCallDialog.vue"
import { sendVideoSignal } from '@/utils/timHelper'
import VoiceConsultationModal from "./VoiceConsultationModal.vue"
export default {
  name: "Index",
  components: {
    PreDiagRecord,
    EnrollForm,
    DispatchMed,
    Pay,
    DiagnosisRecord,
    TreatmentForm,
    TcmRx,
    Patients,
    Treatment,
    PrepareMed,
    TreatmentForm2,
    whitePrescribeModal,
    TcmRx2,
    TcmRxCPD,
    TcmRxCPD2,
    VideoCallDialog,
    VoiceConsultationModal
  },
  filters: {
    PAY_WAY(payWay) {
      switch (payWay) {
        case "wechat":
          return "微信"
        case "aliPay":
          return "支付宝"
      }
    }
  },
  data() {
    return {
      type: this.$route.query.type,
      largeFontMode: false,
      enrollVisible: false,
      diagRecords: [],
      activePatientInfo: {},
      hisTreatmentRecords: [],
      activeDiagTab: "reDiag",
      activeDiagRecord: {
        preTreatmentRecord: null,
        diagRecord: {
          code: ""
        },
        treatmentRecord: {
          symContent: "",
          hisContent: "",
          familyContent: "",
          phyContent: "",
          fdmContent: "",
          diagContent: "",
          chDiagContent: "",
          chYndromeContent: "",
          chTherapyContent: "",
          highPressure: 0,
          lowPressure: 0,
          bloodSugar: 0,
          temperature: 0,
          signs: "", // 新增：体征
          pulse: 0, // 新增：脉搏
          breathe: 0, // 新增：呼吸
          medPositionCode: "",
          medPositionName: "",
          chmedPositionCode: "",
          chmedPositionName: "",
          servePositionCode: "",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0,
          serveFeeSign: "00",
          executeSign: 1
        },
        chmedPrescription: {
          positionCode: "",
          positionName: "",
          doseNum: 1,
          dayDoseNum: 1,
          dayFreq: 1,
          stdPrescriptionCode: '',
          serveFeeSign: "00",
          decoctionCode: "",
          decoctionName: ""
        },
        djPrescription: {
          pharmacyCode: "",
          pharmacyName: "",
          serveFeeSign: "00",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0
        },
        dsPrescription: {
          pharmacyCode: "",
          pharmacyName: "",
          doseNum: 0,
          dayDoseNum: 0
        },
        chmedPrescriptionItemList: [],
        medPrescription: {
          positionCode: "",
          positionName: ""
        },
        medPrescriptionItemList: [],
        servePrescriptionItemList: [],
        djPrescriptionItemList: [],
        dsPrescriptionItemList: []
      },
      searchKeyWord: "",
      prepareVisible: false,
      payVisible: false,
      dispatchVisible: false,
      diagCode: "",
      qrcodeVisible: false,
      payWay: "",
      outOrdList: [],
      sendChmedList: [],
      sendMedList: [],
      chmedPrescription: {},
      medPrescription: {},
      liliaoPrescription: {},
      djPrescription: {},
      dsPrescription: {},
      cardShow: true,
      currentTreatmentTab: '1',
      tizhi: {},
      voiceConsultationVisible: false
    }
  },
  computed: {
    storeCode() {
      return this.$store.getters['user/getStoreCode']
    },
    storeUserCode() {
      return this.$store.getters['user/getUserCode']
    }
  },
  watch: {
    '$route.query.type'(newType) {
      this.type = newType
    }
  },
  provide() {
    return {
      pageData: this
    }
  },
  created() {
    this.largeFontMode = localStorage.getItem('largeFontMode') === 'true'
    document.documentElement.setAttribute('data-large-font', this.largeFontMode)
    if (this.activeDiagRecord.treatmentRecord.code) {
      this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
    }
    this.largeFontMode = localStorage.getItem('largeFontMode') === 'true'
    document.documentElement.setAttribute('data-large-font', this.largeFontMode)
  },
  mounted() {
    this.$nextTick(() => {
      this.handleVideoCallRouteQuery()
    })
    // document.addEventListener('keydown', this.handleGlobalKeydown)
  },
  beforeDestroy() {
    // document.removeEventListener('keydown', this.handleGlobalKeydown)
  },
  methods: {
    async fetchUserSig() {
      try {
        const baseUserId = this.$store.getters['user/getBaseUserId'] || ''
        const res = await getData('base/user/user/user/get/getUserSig', 'get', { baseUserId })
        return res.data?.data?.userSig || res.data?.userSig || ''
      } catch (err) {
        console.error('获取 UserSig 失败', err)
        this.$message.error('获取通话凭证失败')
        return ''
      }
    },
    handleVoiceComplete(payload) {
      // 主诉：matchedSymList.name 空格拼接；为空或不存在时清空主诉
      if (payload.symptomText) {
        this.$set(this.activeDiagRecord.treatmentRecord, 'symContent', payload.symptomText)
      } else {
        this.$set(this.activeDiagRecord.treatmentRecord, 'symContent', '')
      }

      // 中医病
      if (payload.chDiagName) {
        this.$set(this.activeDiagRecord.treatmentRecord, 'chDiagContent', payload.chDiagName)
      }

      // 同步更新 TreatmentForm 的 diagParams，避免 ChiefComplaint 弹出"请选择相关病症"
      if (this.$refs.treatmentForm && payload.chDiagDictionaryCode) {
        this.$refs.treatmentForm.diagParams = {
          ...this.$refs.treatmentForm.diagParams,
          code: 'chDiag',
          diagDictionaryCode: payload.chDiagName || '',
          chiefData: payload.chDiagDictionaryCode,
          commonSign: 1,
          mainSign: 1
        }
      }

      this.$message.success('语音问诊结果已自动填充至诊断表单')
      // 强制刷新子表单
      this.$nextTick(() => {
        if (this.$refs.treatmentForm) this.$refs.treatmentForm.$forceUpdate()
        if (this.$refs.treatmentForm2) this.$refs.treatmentForm2.$forceUpdate()
      })
    },

    /**
     * 弹窗关闭时强制停止录音与 WebSocket，防止后台继续占用麦克风
     */
    handleVoiceDialogClosed() {
      if (this.$refs.voiceConsultationRef) {
        this.$refs.voiceConsultationRef.stopRecording()
        this.$refs.voiceConsultationRef.disconnectWebSocket()
      }
    },
    async handleVideoCallRouteQuery() {
      const { videoCall, roomId, diagRecordCode, callerUserId, userData } = this.$route.query
      if (!videoCall || !roomId) return
      console.log('[视频跳转] 开始加载，callerUserId:', callerUserId, 'userData/diagRecordCode:', diagRecordCode || userData)
      if (callerUserId) {
        try {
          const res = await postData('base/user/user/user/find/findPagination', {
            searchData: {
              sexSign: '',
              weChatSign: '',
              faceSign: '',
              roleSign: '',
              stateSign: '',
              baseUserId: callerUserId
            },
            pageSize: 20,
            pageNo: 1
          })
          const userList = res.data?.list || res.data?.data?.list || res.data?.rows || []
          if (userList.length > 0) {
            const user = userList[0]
            this.activePatientInfo = {
              name: user.name || user.userName || user.nickName || '未知患者',
              sexSign: user.sexSign,
              birthDate: user.birthDate,
              contactPhone: user.contactPhone || user.phone || user.mobile,
              contactAddress: user.contactAddress || user.address,
              code: user.code || user.userCode || user.baseUserId,
              id: user.id
            }
            this.getPhydiagrecord()
          }
        } catch (e) {
          console.error('[视频跳转] 查询用户信息失败', e)
        }
      }
      const recordCode = userData || diagRecordCode
      if (recordCode) {
        this.resetActiveDiagRecord()
        this.activeDiagRecord.diagRecord.code = recordCode
        this.activeDiagRecord.treatmentRecord.diagRecordCode = recordCode
        this.cardShow = true
      }
      this.$nextTick(() => {
        this.$refs.videoCallDialog.open(roomId, this.activePatientInfo, callerUserId)
      })
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, videoCall: undefined, roomId: undefined, diagRecordCode: undefined, callerUserId: undefined, userData: undefined }
      }).catch(() => {})
    },
    async loadPrescriptionData(treatmentRecordCode) {
      try {
        const res = await postData(
          'pharmacy/storage/agentpre/agentprescription/find/gettreatmentrecord',
          { code: treatmentRecordCode }
        )
        this.activeDiagRecord.dsPrescription = res.data?.agentPrescription || {
          pharmacyCode: '',
          pharmacyName: '',
          doseNum: 0,
          dayDoseNum: 0
        }
        this.activeDiagRecord.dsPrescriptionItemList = res.data?.agentPrescriptionItemList || []
        this.activeDiagRecord.djPrescription = res.data?.chagentPrescription || {
          pharmacyCode: '',
          pharmacyName: '',
          serveFeeSign: '00',
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0
        }
        this.activeDiagRecord.djPrescriptionItemList = res.data?.chagentPrescriptionItemList || []
      } catch (e) {
        console.error('[视频跳转] 加载处方数据失败', e)
      }
    },
    findHisDiagRecord(patientId) {
      const bgPath = "clinic/treatment/treatment/diagrecord"
      const pd = {
        storeCode: this.storeCode,
        stateSign: "5",
        patientId
      }
      return findPage(bgPath, pd, 3, 1).then(res => {
        this.hisTreatmentRecords = res.data.list
      })
    },
    async notifyHangup(callerUserId, roomId) {
      if (!callerUserId) return
      try {
        await sendVideoSignal(callerUserId, {
          type: 'VIDEO_CALL_HANGUP',
          roomId,
          timestamp: Date.now()
        })
      } catch (e) {
        console.error('[IM] 发送挂断信令失败', e)
      }
    },
    calculateAge(birthDateStr) {
      if (!birthDateStr) return '-'
      const birthDate = new Date(birthDateStr)
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      if (today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age < 0 ? 0 : age
    },
    getStateText(stateSign) {
      const stateMap = {
        '1': '待诊断',
        '2': '已开方',
        '3': '已配药',
        '4': '待发药'
      }
      return stateMap[stateSign] || '未知'
    },
    getPhydiagrecord() {
      if (!this.activePatientInfo.code) return
      const pd = {
        "userCode": this.activePatientInfo.code,
        "storeCode": this.storeCode
      }
      postData('health/diagnosis/physique/phydiagrecord/find/findphyrecord', pd).then(response => {
        if (response.data) {
          this.tizhi = response.data
        } else {
          this.tizhi = {}
        }
      }).catch(() => {
        this.tizhi = {}
      })
    },
    getTizhiText() {
      if (Array.isArray(this.tizhi)) {
        return this.tizhi.map(item => item.physiqueName || item.name).join('、') || '未辨识'
      }
      return this.tizhi.physiqueName || this.tizhi.name || '未辨识'
    },
    getTizhiType() {
      const text = this.getTizhiText()
      const typeMap = {
        '平和质': 'success',
        '气虚质': 'warning',
        '阳虚质': 'danger',
        '阴虚质': '',
        '痰湿质': 'info',
        '湿热质': 'danger',
        '血瘀质': '',
        '气郁质': 'info',
        '特禀质': 'warning'
      }
      for (const key in typeMap) {
        if (text.includes(key)) return typeMap[key]
      }
      return 'info'
    },
    handleTreatmentTabChange(key) {
      this.currentTreatmentTab = key
    },
    toggleLargeFont() {
      this.largeFontMode = !this.largeFontMode
      localStorage.setItem('largeFontMode', this.largeFontMode)
      document.documentElement.setAttribute('data-large-font', this.largeFontMode)
      this.$emit('large-font-changed', this.largeFontMode)
    },
    resetActiveDiagRecord() {
      this.activeDiagRecord = {
        preTreatmentRecord: null,
        diagRecord: {
          code: ""
        },
        treatmentRecord: {
          symContent: "",
          hisContent: "",
          familyContent: "",
          phyContent: "",
          fdmContent: "",
          diagContent: "",
          chDiagContent: "",
          chYndromeContent: "",
          chTherapyContent: "",
          highPressure: 0,
          lowPressure: 0,
          bloodSugar: 0,
          temperature: 0,
          signs: "", // 新增：体征
          pulse: 0, // 新增：脉搏
          breathe: 0, // 新增：呼吸
          medPositionCode: "",
          medPositionName: "",
          chmedPositionCode: "",
          chmedPositionName: "",
          servePositionCode: "",
          doseNum: 1,
          dayDoseNum: 1,
          dayFreq: 1,
          serveFeeSign: "00"
        },
        chmedPrescription: {
          positionCode: "",
          positionName: "",
          doseNum: 1,
          dayDoseNum: 1,
          dayFreq: 1,
          stdPrescriptionCode: '',
          serveFeeSign: "00"
        },
        djPrescription: {
          pharmacyCode: "",
          pharmacyName: "",
          serveFeeSign: "00",
          doseNum: 1,
          dayDoseNum: 1,
          dayFreq: 1
        },
        dsPrescription: {
          pharmacyCode: "",
          pharmacyName: "",
          doseNum: 1,
          dayDoseNum: 1
        },
        chmedPrescriptionItemList: [],
        medPrescription: {
          positionCode: "",
          positionName: ""
        },
        medPrescriptionItemList: [],
        servePrescriptionItemList: [],
        djPrescriptionItemList: [],
        dsPrescriptionItemList: []
      }
      this.searchKeyWord = ""
    },
    showQrCode(url) {
      this.payVisible = false
      this.prepareVisible = false
      this.qrcodeVisible = true
      this.$nextTick(() => {
        new QRCode(this.$refs.qrcode, {
          text: url,
          width: 274,
          height: 274,
          colorDark: "#000000",
          colorLight: "#ffffff"
        })
      })
    },
    dispatchMed() {
      const pd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      postData('clinic/treatment/treatment/diagrecord/do/virtualsend', pd).then(res => {
        if (res.data) {
          if (this.activeDiagRecord.chmedPrescription.outOrdCode) {
            const chmedCode = this.activeDiagRecord["chmedPrescription"]["outOrdCode"]
            getByCode("clinic/inventory/change/outord", chmedCode)
              .then(res => {
                this.sendChmedList = res.data.body["outOrdItem"]
                this.activeDiagRecord.chmedPrescription = { ...this.activeDiagRecord.chmedPrescription, ...res.data }
              })
          }
          if (this.activeDiagRecord.medPrescription.outOrdCode) {
            const medCode = this.activeDiagRecord["medPrescription"]["outOrdCode"]
            getByCode("clinic/inventory/change/outord", medCode)
              .then(res => {
                this.sendMedList = res.data.body["outOrdItem"]
                this.activeDiagRecord.medPrescription = {
                  ...this.activeDiagRecord.medPrescription,
                  ...res.data
                }
              })
          }
          this.dispatchVisible = true
        } else {
          this.$message.success('无发药流程，诊断完成')
          this.updateDiagRecord()
          this.updatePatientInfo()
        }
      })
    },
    resetDiag() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/resetdiag", pd)
        .then(res => {
          this.prepareVisible = false
          this.$message.success("重诊成功")
          this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
          console.log(this.activeDiagRecord)
        })
    },
    pay() {
      this.payVisible = true
    },
    prescriptionConfirmation() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/treatmentcheckprescription", pd)
        .then(res => {
          this.prepareVisible = false
          this.$message.success("确认成功")
        })
    },
    prepareMed() {
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      const treatPd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      const hasChmedOrMed = this.activeDiagRecord.chmedPrescriptionItemList.length > 0 ||
                        this.activeDiagRecord.medPrescriptionItemList.length > 0
      const hasDjOrDs = this.activeDiagRecord.djPrescriptionItemList.length > 0 ||
                   this.activeDiagRecord.dsPrescriptionItemList.length > 0
      const requests = []
      console.log(hasDjOrDs)
      if (hasChmedOrMed) {
        requests.push(postData("clinic/treatment/treatment/diagrecord/do/initoutord", pd))
      }
      if (hasDjOrDs) {
        requests.push(postData("pharmacy/storage/agentpre/agentprescription/do/treatmentcheckprescription", pd))
      }
      Promise.all(requests)
        .then(() => {
          return this.$refs.treatment.getTreatmentRecord(treatPd.code)
        })
        .then(res => {
          this.$message.success('操作成功')
        })
        .catch(err => {
          console.error("配药操作失败:", err)
          this.$message.error('操作失败，请重试')
        })
    },
    peiyao() {
      const hasPrescriptionContent = [
        this.activeDiagRecord.chmedPrescriptionItemList,
        this.activeDiagRecord.medPrescriptionItemList,
        this.activeDiagRecord.servePrescriptionItemList,
        this.activeDiagRecord.djPrescriptionItemList,
        this.activeDiagRecord.dsPrescriptionItemList
      ].some(list => list && list.length > 0)

      if (!hasPrescriptionContent) {
        this.$message.warning('请先填写处方内容')
        return
      }
      const pd = {
        code: this.activeDiagRecord.diagRecord.code
      }
      const treatPd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      if (this.activeDiagRecord.diagRecord.stateSign === "2") {
        postData("clinic/treatment/treatment/diagrecord/do/dispensing", pd)
          .then(() => {
            this.prepareVisible = true
          })
          .finally(() => {
            this.updateDiagRecord()
            this.updatePatientInfo()
          })
      } else {
        this.$refs.treatment.getTreatmentRecord(treatPd.code)
        this.prepareVisible = true
      }
    },
    handleDiagnosisRecord(command) {
      console.log(command)
      switch (command.type) {
        case "copyChmed":
          this.activeDiagRecord.treatmentRecord.doseNum = command.data.head.doseNum
          this.activeDiagRecord.treatmentRecord.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.treatmentRecord.dayFreq = command.data.head.dayFreq | "1"
          this.activeDiagRecord.treatmentRecord.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.chmedPrescription.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.chmedPrescription.dayFreq = command.data.head.dayFreq
          this.activeDiagRecord.chmedPrescription.stdPrescriptionCode = command.data.head.stdPrescriptionCode
          this.activeDiagRecord.chmedPrescription.doseNum = command.data.head.doseNum
          this.activeDiagRecord.chmedPrescription.positionCode = command.data.head.positionCode
          this.activeDiagRecord.chmedPrescription.positionName = command.data.head.positionName
          this.activeDiagRecord.chmedPrescription.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.chmedPrescriptionItemList = command.data.body.chmedPrescriptionItem
          break
        case "copyMed":
          this.activeDiagRecord.medPrescription.dayDoseNum = command.data.head.dayDoseNum
          this.activeDiagRecord.medPrescription.dayFreq = command.data.head.dayFreq
          this.activeDiagRecord.medPrescription.doseNum = command.data.head.doseNum
          this.activeDiagRecord.medPrescription.positionCode = command.data.head.positionCode
          this.activeDiagRecord.medPrescription.positionName = command.data.head.positionName
          this.activeDiagRecord.medPrescription.serveFeeSign = command.data.head.serveFeeSign
          this.activeDiagRecord.medPrescriptionItemList = command.data.body.medPrescriptionItem
          break
        case "copyServe":
          this.activeDiagRecord.servePrescriptionItemList = command.data.body.servePrescriptionItem
          break
        default:
          break
      }
      this.cardShow = !this.cardShow
    },
    handleTreatmentCommand(command) {
      switch (command.type) {
        case "finish":
          this.updateDiagRecord()
          this.updatePatientInfo()
          break
        default:
          break
      }
    },
    handleOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.tcmRx.open()
      })
    },
    handleOpenClick2() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.tcmRx2.open()
      })
    },
    handlePhyOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.PhysiotherapyRef.open()
      })
    },
    handleCPDOpenClick() {
      this.searchKeyWord = [
        this.activeDiagRecord.treatmentRecord.symContent.trim(),
        this.activeDiagRecord.treatmentRecord.hisContent.trim(),
        this.activeDiagRecord.treatmentRecord.familyContent.trim(),
        this.activeDiagRecord.treatmentRecord.phyContent.trim(),
        this.activeDiagRecord.treatmentRecord.fdmContent.trim(),
        this.activeDiagRecord.treatmentRecord.diagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chDiagContent.trim(),
        this.activeDiagRecord.treatmentRecord.chYndromeContent.trim(),
        this.activeDiagRecord.treatmentRecord.chTherapyContent.trim()
      ].filter(item => item !== "").join(" ")
      this.$nextTick(() => {
        this.$refs.TcmRxCPDRef.open()
      })
    },
    handleShow() {
    },
    handlePopupClick(row) {
      console.log('[推荐处方] 原始数据:', row, '当前tab:', this.currentTreatmentTab)

      // 兼容后端可能返回的嵌套 data 结构
      const data = row.data || row
      const head = data.head || {}
      const body = data.body || {}

      if (!head.code) {
        this.$message.warning('处方数据异常，请重试')
        return
      }

      // 2. 构建物料列表 - 字段名要与表格组件期望的一致
      const rawItems = body["stdPrescriptionItem"] || body["chmedPrescriptionItem"] || []
      const itemList = rawItems.map((item) => {
        return {
          // 物料基本信息
          materielName: item["materielName"] || item["name"] || item["medName"] || '',
          materielCode: item["materielCode"] || item["code"] || item["medCode"] || '',
          // 数量相关
          sellingNum: parseFloat(item["sellingNum"] || item["singleNum"] || 0),
          doseNum: parseFloat(item["sellingNum"] || 0) * parseFloat(head.doseNum || 1),
          singleNum: parseFloat(item["sellingNum"] || 0),
          // 其他字段
          qualitySign: item["qualitySign"] || "1",
          medAdvice: item["medAdvice"] || item["usage"] || '',
          dayFreq: parseInt(item["dayFreq"] || head["dayFreq"] || 1),
          freqNum: parseInt(item["freqNum"] || 1),
          // 保留原始数据
          ...item
        }
      }).filter(item => item.materielName) // 过滤掉没有名称的空数据

      // 根据当前tab决定更新哪个处方列表
      if (this.currentTreatmentTab === '4') {
        // 代煎处方：更新 djPrescription 和 djPrescriptionItemList
        this.$set(this.activeDiagRecord.djPrescription, 'serveFeeSign', head["decoctSign"] || '00')
        this.$set(this.activeDiagRecord.djPrescription, 'doseNum', parseInt(head["doseNum"]) || 1)
        this.$set(this.activeDiagRecord.djPrescription, 'dayDoseNum', parseInt(head["dayDoseNum"]) || 1)
        this.$set(this.activeDiagRecord.djPrescription, 'dayFreq', parseInt(head["dayFreq"]) || 1)
        this.$set(this.activeDiagRecord.djPrescription, 'stdPrescriptionCode', head["code"] || '')
        this.$set(this.activeDiagRecord, 'djPrescriptionItemList', itemList)
      } else if (this.currentTreatmentTab === '5') {
        // 代售处方：更新 dsPrescription 和 dsPrescriptionItemList
        this.$set(this.activeDiagRecord.dsPrescription, 'doseNum', parseInt(head["doseNum"]) || 1)
        this.$set(this.activeDiagRecord.dsPrescription, 'dayDoseNum', parseInt(head["dayDoseNum"]) || 1)
        this.$set(this.activeDiagRecord.dsPrescription, 'stdPrescriptionCode', head["code"] || '')
        this.$set(this.activeDiagRecord, 'dsPrescriptionItemList', itemList)
      } else {
        // 饮片处方（默认）：更新 chmedPrescription 和 chmedPrescriptionItemList
        this.$set(this.activeDiagRecord.chmedPrescription, 'serveFeeSign', head["decoctSign"] || '00')
        this.$set(this.activeDiagRecord.chmedPrescription, 'doseNum', parseInt(head["doseNum"]) || 1)
        this.$set(this.activeDiagRecord.chmedPrescription, 'dayDoseNum', parseInt(head["dayDoseNum"]) || 1)
        this.$set(this.activeDiagRecord.chmedPrescription, 'dayFreq', parseInt(head["dayFreq"]) || 1)
        this.$set(this.activeDiagRecord.chmedPrescription, 'stdPrescriptionCode', head["code"] || '')
        this.$set(this.activeDiagRecord.chmedPrescription, 'positionCode', head["positionCode"] || '')
        this.$set(this.activeDiagRecord.chmedPrescription, 'positionName', head["positionName"] || '')
        this.$set(this.activeDiagRecord, 'chmedPrescriptionItemList', itemList)
      }

      // 3. 同步更新 treatmentRecord 中的相关字段
      this.$set(this.activeDiagRecord.treatmentRecord, 'doseNum', parseInt(head["doseNum"]) || 1)
      this.$set(this.activeDiagRecord.treatmentRecord, 'dayDoseNum', parseInt(head["dayDoseNum"]) || 1)
      this.$set(this.activeDiagRecord.treatmentRecord, 'dayFreq', parseInt(head["dayFreq"]) || 1)

      this.$message.success(`已添加 ${itemList.length} 味药材`)

      // 4. 强制刷新组件
      this.$nextTick(() => {
        if (this.$refs.treatment) {
          this.$refs.treatment.$forceUpdate()
          // 根据当前tab刷新对应的表格引用
          const tableRefMap = { '1': 'chmedTable', '4': 'djTable', '5': 'dsTable' }
          const refName = tableRefMap[this.currentTreatmentTab]
          if (refName && this.$refs.treatment.$refs[refName]) {
            this.$refs.treatment.$refs[refName].$forceUpdate()
          }
        }
      })
      console.log('=== 处方数据检查 ===')
      console.log('tab:', this.currentTreatmentTab)
      console.log('head:', this.currentTreatmentTab === '4' ? this.activeDiagRecord.djPrescription : this.currentTreatmentTab === '5' ? this.activeDiagRecord.dsPrescription : this.activeDiagRecord.chmedPrescription)
      console.log('itemList:', this.currentTreatmentTab === '4' ? this.activeDiagRecord.djPrescriptionItemList : this.currentTreatmentTab === '5' ? this.activeDiagRecord.dsPrescriptionItemList : this.activeDiagRecord.chmedPrescriptionItemList)
    },
    handlePhysiotherapySelect(row) {
      console.log(row, 8888)
      this.activeDiagRecord.servePrescriptionItemList.push({
        materielName: row.head.materielName,
        materielCode: row.head.materielCode,
        sellingNum: row.head.sellingNum,
        medAdvice: row.head.medAdvice,
        dayFreq: row.head.dayFreq,
        freqNum: row.head.freqNum
      })
    },
    handleMedicationSelect(row) {
      this.activeDiagRecord.medPrescription = {
        ...this.activeDiagRecord.medPrescription,
        "positionCode": row.head.positionCode,
        "positionName": row.head.positionName,
        "totalQuantity": row.head.totalQuantity || 1
      }
      console.log(row)
      this.activeDiagRecord.medPrescriptionItemList.push({
        materielName: row.head.materielName,
        materielCode: row.head.materielCode,
        sellingNum: row.head.sellingNum || 1,
        qualitySign: "1",
        medAdvice: row.head.medAdvice,
        dayFreq: row.head.dayFreq,
        freqNum: row.head.freqNum
      })
    },
    handleTreatment() {
      this.$refs.treatment.handleTreatment()
    },
    enroll() {
      this.enrollVisible = true
    },
    handleEnroll() {
      this.$refs.enrollForm.submitEnrollForm()
    },
    handleEnrollCommand(command) {
      const url = "clinic/treatment/treatment/diagrecord/do/storeenroll"
      const pd = {
        ...command.data
      }
      postData(url, pd)
        .then(res => {
          this.$message.success("挂号成功!")
          this.enrollVisible = false
          this.updateDiagRecord()
        })
    },
    updateDiagRecord() {
      this.$refs.patients.findDiagRecord()
    },
    updatePatientInfo() {
      this.$refs.patients.handleClickDiagRecord(this.activeDiagRecord.diagRecord)
    },
    printOpen() {
      const data = {
        data: this.activePatientInfo,
        body: this.activeDiagRecord
      }
      this.$refs.whitePrescribeModal.open(data)
    },
    saveChufang() {
      let url
      const pd = {
        "code": this.activeDiagRecord.treatmentRecord.code,
        "stdPrescriptionCode": this.activeDiagRecord.chmedPrescription.stdPrescriptionCode
      }
      if (this.currentTreatmentTab === '4') {
        url = "pharmacy/storage/agentpre/agentprescription/do/treatmentchmedprescription"
        const filteredDjItemList = this.activeDiagRecord.djPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )
        Object.assign(pd, {
          pharmacyCode: this.activeDiagRecord.djPrescription.pharmacyCode,
          pharmacyName: this.activeDiagRecord.djPrescription.pharmacyName,
          serveFeeSign: this.activeDiagRecord.djPrescription.serveFeeSign,
          doseNum: this.activeDiagRecord.djPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.djPrescription.dayDoseNum,
          dayFreq: this.activeDiagRecord.djPrescription.dayFreq,
          chmedItemList: filteredDjItemList
        })
      } else if (this.currentTreatmentTab === '5') {
        url = "pharmacy/storage/agentpre/agentprescription/do/treatmentmedprescription"
        const filteredDsItemList = this.activeDiagRecord.dsPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )
        Object.assign(pd, {
          pharmacyCode: this.activeDiagRecord.dsPrescription.pharmacyCode,
          pharmacyName: this.activeDiagRecord.dsPrescription.pharmacyName,
          doseNum: this.activeDiagRecord.dsPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.dsPrescription.dayDoseNum,
          medItemList: filteredDsItemList
        })
      } else if (this.currentTreatmentTab === '3') {
        url = "clinic/treatment/treatment/diagrecord/do/treatmentserveprescription"
        const filteredServeItemList = this.activeDiagRecord.servePrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )
        Object.assign(pd, {
          medPositionCode: this.activeDiagRecord.medPrescription.positionCode,
          medPositionName: this.activeDiagRecord.medPrescription.positionName,
          serveItemList: filteredServeItemList
        })
      } else if (this.currentTreatmentTab === '2') {
        url = "clinic/treatment/treatment/diagrecord/do/treatmentmedprescription"
        const filteredMedItemList = this.activeDiagRecord.medPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )
        Object.assign(pd, {
          medPositionCode: this.activeDiagRecord.medPrescription.positionCode,
          medPositionName: this.activeDiagRecord.medPrescription.positionName,
          medItemList: filteredMedItemList
        })
      } else {
        url = "clinic/treatment/treatment/diagrecord/do/treatmentchmedprescription"
        const filteredChmedItemList = this.activeDiagRecord.chmedPrescriptionItemList.filter(item =>
          item.materielName && item.materielName.trim() !== ''
        )
        Object.assign(pd, {
          chmedPositionCode: this.activeDiagRecord.chmedPrescription["positionCode"],
          doseNum: this.activeDiagRecord.chmedPrescription.doseNum,
          dayDoseNum: this.activeDiagRecord.chmedPrescription.dayDoseNum,
          dayFreq: this.activeDiagRecord.chmedPrescription.dayFreq,
          serveFeeSign: this.activeDiagRecord.chmedPrescription.serveFeeSign,
          chmedItemList: filteredChmedItemList,
          dayNum: this.activeDiagRecord.chmedPrescription.dayNum
        })
      }
      console.log(pd, this.activeDiagRecord.chmedPrescription.stdPrescriptionCode)
      postData(url, pd)
        .then(res => {
          this.$refs.treatment.getTreatmentRecord(res.data.code)
          this.$message.success("保存成功!")
        })
    },
    clearPrescription() {
      let url
      const pd = {
        code: this.activeDiagRecord.treatmentRecord.code
      }
      if (this.currentTreatmentTab === '3') {
        url = "clinic/treatment/treatment/diagrecord/do/removeserveprescription"
      } else if (this.currentTreatmentTab === '2') {
        url = "clinic/treatment/treatment/diagrecord/do/removemedprescription"
      } else {
        url = "clinic/treatment/treatment/diagrecord/do/removechmedprescription"
      }
      postData(url, pd).then(res => {
        console.log(res)
        this.$message.success('操作成功')
        this.$refs.treatment.getTreatmentRecord(this.activeDiagRecord.treatmentRecord.code)
      })
    },
    clearInformation() {
      this.activePatientInfo = {}
    },
    /**
     * 全局快捷键：Ctrl + Shift + A 添加药品
     */
    handleGlobalKeydown(e) {
      // 只在诊疗卡片显示且有患者时生效
      if (!this.cardShow || !this.activePatientInfo || !Object.keys(this.activePatientInfo).length) return
      // 如果有弹窗打开，不处理（避免冲突）
      if (document.querySelector('.v-modal') || document.querySelector('.el-dialog__wrapper:not([style*="display: none"])')) {
        return
      }
      // Ctrl + Shift + A 触发当前治疗 tab 添加药品
      if (e.ctrlKey && e.shiftKey && (e.key === 'a' || e.key === 'A')) {
        e.preventDefault()
        if (this.$refs.treatment && this.$refs.treatment.addRow) {
          this.$refs.treatment.addRow()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.history-container {
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  .flex-row {
    height: 100%;
  }
}
.history-section {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .history-content {
    flex: 1;
    overflow-y: auto;
    padding-right: 8px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
      &:hover {
        background: #a8a8a8;
      }
    }
  }
  .no-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .no-data-label {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
  }
}
  .history-timeline {
    padding: 10px 0;

    .history-item {
      margin-bottom: 16px;
      padding-right: 8px;
    }
  }
}

.register-con {
  margin-right: 16px;
  width: 15%;
  .register-logo {
    width: 176px;
    height: 56px;
    margin-bottom: 12px;
  }
}

.patient-con {
  width: 488px;
  margin-right: 16px;

  .info {
    margin-bottom: 16px;

    .info-con {
      padding: 16px;

      .profile {
        width: 64px;
        height: 64px;
        margin-right: 16px;

      }

      .info-wrapper {
        .name {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 20px;
          color: #1D2129;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 8px;
        }

        .info-item {
          .label {
            font-family: Roboto, Roboto, serif;
            font-weight: normal;
            font-size: 14px;
            color: #999999;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .value {
            font-family: Roboto, Roboto, serif;
            font-weight: normal;
            font-size: 14px;
            color: #4E5969;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .divider-line {
          height: 14px;
          border: 1px solid #E5E6EB;
          margin: 0 8px;
        }
      }

    }
  }

  .diagnosis {
    flex: 1;

    .diagnosis-con {
      .reDiag {
        flex: 1;
      }

      .dig-info {
        height: 65vh;

        &::-webkit-scrollbar {
          width: 0;
        }

        .date-picker {
          margin-bottom: 12px;
        }

        .diagnosis-record-con {
          .record {
            margin-bottom: 16px;
          }
        }
      }

      .no-data {
        height: 598px;

        .no-data-img {
          height: 170px;
          width: 170px;
        }

        .no-data-label {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #606C80;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }

}

.treatment-con {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 85%;
  overflow: auto;
  .item-con {
    .label-con {
      margin-bottom: 12px;

      .icon {
        width: 4px;
        height: 14px;
        background: #165DFF;
        border-radius: 0 0 0 0;
        margin-right: 8px;
      }

      .label {
        font-family: PingFang SC, PingFang SC, serif;
        font-weight: bold;
        font-size: 16px;
        color: #1D2129;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .divider-line {
    border-radius: 0 0 0 0;
    border: 1px solid #E5E6EB;
    margin: 10px 0;
  }

  .body {
  flex: 1;
  min-height: 300px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
}
}

.add-btn-con {
  background: #FFFFFF;
  height: 46px;
  border: 1px solid #E5E6EB;
  padding: 7px;

  &:hover {
    cursor: pointer;
  }

  .add-btn {
    background: #F7F8FA;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;

    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.treatment-input {
  width: 180px;
}

::v-deep .el-timeline {
  padding: 2px;
}

::v-deep .el-input-number--small {
  line-height: 30px;
}

.pay-header {
  margin-bottom: 73px;

  .icon-img {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }

  .tip {
    font-family: 思源黑体 CN PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 24px;
    line-height: 22px;
  }
}

::v-deep .qrcode-con {
  background-image: url("../../../../../assets/list/qrcode.png");
  background-repeat: no-repeat;
  height: 676px;
  border-radius: 30px 30px 0 0;
  padding-top: 105px;
}
.treatment-body-card {
  flex: 1;
  display: flex;
  flex-direction: column;

  ::v-deep .el-card__body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
  }
}
.large-font-mode {
  .patients {
    .list-item {
      .name {
        font-size: 16px !important;
      }
      .info {
        font-size: 15px !important;
      }
    }
  }

  .med-table {
    font-size: 16px;
    th, td {
      font-size: 16px !important;
      padding: 10px !important;
    }
  }

  .el-dialog {
    font-size: 18px;
    .el-dialog__header {
      font-size: 20px;
    }
    .el-dialog__body {
      font-size: 18px;
    }
  }

  .gh-table {
    font-size: 16px !important;
    th, td {
      font-size: 16px !important;
    }
  }

  .el-input__inner,
  .el-select,
  .el-textarea {
    font-size: 16px !important;
    padding: 8px 15px !important;
  }
}

:root {
  &[data-large-font="true"] {
    font-size: 16px;
  }
}

.treatment-con {
  &:global(.large-font) {
    .el-button {
      min-height: 40px;
      font-size: 16px;
    }

    .info-wrapper {
      font-size: 18px;

      .name {
        font-size: 24px;
      }
    }
  }
}
.patient-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  width: 100%;
}

.header-left {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-shrink: 0;
}

.header-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid #f0f2f5;
}

.header-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  .patient-name {
    font-size: 20px;
    font-weight: 600;
    color: #1d2129;
    margin: 0;
    font-family: PingFang SC, sans-serif;
  }

  .patient-meta {
    font-size: 13px;
    color: #606266;
    background-color: #f2f3f5;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .patient-phone {
    font-size: 14px;
    color: #165dff;
    font-weight: 500;
    font-family: Roboto, sans-serif;
  }
}

.tag-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .el-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
}

.header-right {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.info-line {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
  width: 100%;

  &.info-with-action {
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  &.secondary-line {
    padding-left: 0;
    color: #86909c;
    font-size: 12px;
  }
}

.info-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.info-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  label {
    color: #909399;
    font-weight: normal;
    font-size: 12px;
  }

  value {
    color: #1d2129;
    font-weight: 500;
    font-size: 13px;

    &.state-1 { color: #ff7d00; }
    &.state-2 { color: #165dff; }
    &.state-3 { color: #00b42a; }
    &.state-4 { color: #722ed1; }
  }
}

.divider {
  color: #e5e6eb;
  font-weight: 300;
  font-size: 12px;
}

.switch-btn {
  flex-shrink: 0;
  font-weight: 500;
  padding: 7px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(22, 93, 255, 0.15);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(22, 93, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
}

.placeholder {
  flex: 1;
}

@media screen and (max-width: 1200px) {
  .patient-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-right {
    width: 100%;
    padding-left: 71px;
  }

  .info-with-action {
    flex-wrap: wrap;
    gap: 10px;

    .switch-btn {
      margin-left: auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .info-with-action {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;

    .switch-btn {
      margin-left: 0;
      width: 100%;
    }
  }
}

.large-font-mode {
  .patient-header {
    .patient-name {
      font-size: 24px;
    }
    .patient-meta, .patient-phone {
      font-size: 15px;
    }
    .info-item label, .info-item value {
      font-size: 15px;
    }
    .header-avatar {
      width: 72px;
      height: 72px;
    }
    .switch-btn {
      font-size: 14px;
      padding: 9px 18px;
    }
  }
}
.tizhi-tag {
  font-weight: 500;
  border-radius: 4px;
  margin: 0 8px;
  i {
    margin-right: 4px;
    font-size: 12px;
  }

  &.el-tag--success {
    background-color: #00b42a;
    border-color: #00b42a;
  }
  &.el-tag--warning {
    background-color: #ff7d00;
    border-color: #ff7d00;
  }
  &.el-tag--danger {
    background-color: #f53f3f;
    border-color: #f53f3f;
  }
  &.el-tag--info {
    background-color: #86909c;
    border-color: #86909c;
  }
}

.info-row {
  gap: 8px;

  .patient-name {
    margin-right: 4px;
  }

  .patient-meta {
    margin-right: 4px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* 语音问诊弹窗样式适配：让深色语音页面在 Element Dialog 内正常展示 */
::v-deep .voice-consultation-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e5e6eb;
    padding: 15px 20px;
    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
    }
  }
  .el-dialog__body {
    padding: 0;
    height: 560px;
    overflow: hidden;
    background: #0a0e27;
    border-radius: 0 0 4px 4px;
  }
  .voice-input-page {
    height: 100%;
    min-height: unset;
    border-radius: 0;
    padding: 24px 24px 32px;
  }
}
</style>
